import { Visibility } from 'globalTypes'

export const getItemVisibility = (
  visibility: Visibility,
  need_registration: boolean
) => {
  if (!visibility) {
    return null
  }

  if (need_registration) {
    return 'need_registration'
  }

  return visibility
}
